import { atom } from 'recoil';

export const currentMetric = atom({
  key: 'currentMetric', // unique ID (with respect to other atoms/selectors)
  default: {
    title: 'All Connections',
    key: 'allconnections',
  }, // default value (aka initial value)
});
